<table mat-table [dataSource]="data" [trackBy]="trackByUserId" class="users-table w-100" matSort [matSortActive]="initialSort.active" matSortDisableClear [matSortDirection]="initialSort.direction" matSortStart="desc">
  <ng-container matColumnDef="profile_image">
    <mat-header-cell mat-header-cell *matHeaderCellDef></mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row" class="profile-image-column">
      <!-- Videos lead. On Jowa a profile's first media is usually a video, so
           the column shows what the deck shows, in the deck's order. -->
      <sa-profile-video-tile *ngFor="let video of videosFor(row); let i = index"
                             class="m-1" [video]="video" [siblings]="videosFor(row)"
                             [title]="rowTitle(row)"></sa-profile-video-tile>

      <div class="profile-image-container">
        <img class="profile-image m-1 img-loading" *ngIf="row.profile_images[0]" [src]="row.profile_images[0].image_url" (load)="onImageLoad($event)" (error)="onImageError($event)"/>
        <img class="profile-image-extended m-1" *ngIf="row.profile_images[0]" [src]="row.profile_images[0].image_url" (load)="onImageLoad($event)" (error)="onImageError($event)"/>
      </div>
      
      <div class="profile-image-container">
        <img class="profile-image m-1 img-loading" *ngIf="row.profile_images[1]" [src]="row.profile_images[1].image_url" (load)="onImageLoad($event)" (error)="onImageError($event)"/>
        <img class="profile-image-extended m-1" *ngIf="row.profile_images[1]" [src]="row.profile_images[1].image_url" (load)="onImageLoad($event)" (error)="onImageError($event)"/>
      </div>

      <div class="profile-image-container">
        <img class="profile-image m-1 img-loading" *ngIf="row.profile_images[2]" [src]="row.profile_images[2].image_url" (load)="onImageLoad($event)" (error)="onImageError($event)"/>
        <img class="profile-image-extended m-1" *ngIf="row.profile_images[2]" [src]="row.profile_images[2].image_url" (load)="onImageLoad($event)" (error)="onImageError($event)"/>
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="profile_image_mobile">
    <mat-header-cell mat-header-cell *matHeaderCellDef></mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row" class="profile-image-column">
      <sa-profile-video-tile *ngIf="videosFor(row).length" class="m-1"
                             [video]="videosFor(row)[0]" [siblings]="videosFor(row)"
                             [title]="rowTitle(row)"></sa-profile-video-tile>

      <div class="profile-image-container">
        <img class="profile-image m-1 img-loading" *ngIf="row.profile_images[0]" [src]="row.profile_images[0].image_url" (load)="onImageLoad($event)" (error)="onImageError($event)"/>
        <img class="profile-image-extended m-1" *ngIf="row.profile_images[0]" [src]="row.profile_images[0].image_url" (load)="onImageLoad($event)" (error)="onImageError($event)"/>
      </div>
      
      <div class="profile-image-container">
        <img class="profile-image m-1 img-loading" *ngIf="row.profile_images[1]" [src]="row.profile_images[1].image_url" (load)="onImageLoad($event)" (error)="onImageError($event)"/>
        <img class="profile-image-extended m-1" *ngIf="row.profile_images[1]" [src]="row.profile_images[1].image_url" (load)="onImageLoad($event)" (error)="onImageError($event)"/>
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">
      <button mat-icon-button color="primary" (click)="userClicked.emit(row)" aria-label="View">
        <mat-icon>visibility</mat-icon>
      </button>
      <button mat-icon-button color="primary" *ngIf="!row.hidden_under_review" (click)="userPutUnderReviewClicked.emit(row)" aria-label="Ban">
        <mat-icon>remove_circle</mat-icon>
      </button>
      <button mat-icon-button color="primary" *ngIf="row.hidden_under_review" (click)="userRemoveFromReviewClicked.emit(row)" aria-label="Unban">
        <mat-icon>add_circle</mat-icon>
      </button>
      <button mat-icon-button class="fa-button" color="primary" *ngIf="!row.is_banned" (click)="userBanClicked.emit(row)" aria-label="Ban">
        <fa-icon [icon]="faSkullCrossbones"></fa-icon>
      </button>
      <button mat-icon-button class="fa-button fa-button-gray" *ngIf="row.is_banned" (click)="userUnBanClicked.emit(row)" aria-label="Unban">
        <fa-icon [icon]="faSkullCrossbones"></fa-icon>
      </button>
      <button mat-icon-button class="fa-button" color="primary" *ngIf="!row.hidden_silent" (click)="userSilentHideClicked.emit(row)" aria-label="Ban">
        <fa-icon [icon]="faGhost"></fa-icon>
      </button>
      <button mat-icon-button class="fa-button fa-button-gray" *ngIf="row.hidden_silent" (click)="userSilentUnhideClicked.emit(row)" aria-label="Unban">
        <fa-icon [icon]="faGhost"></fa-icon>
      </button>
      <button mat-icon-button color="primary" (click)="userDeleteClicked.emit(row)" aria-label="Delete">
        <mat-icon>delete_forever</mat-icon>
      </button>
      <button mat-icon-button color="primary" (click)="userBoostClicked.emit(row)" aria-label="Boost">
        <mat-icon>arrow_circle_up</mat-icon>
      </button>
      <button mat-icon-button color="primary" (click)="userDeboostClicked.emit(row)" aria-label="Deboost">
        <mat-icon>arrow_circle_down</mat-icon>
      </button>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions_mobile">
    <mat-header-cell mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">
      <button mat-icon-button color="primary" (click)="userClicked.emit(row)" aria-label="View">
        <mat-icon>visibility</mat-icon>
      </button>
      <button mat-icon-button color="primary" *ngIf="!row.hidden_under_review" (click)="userBanClicked.emit(row)" aria-label="Ban">
        <mat-icon>remove_circle</mat-icon>
      </button>
      <button mat-icon-button color="primary" *ngIf="row.hidden_under_review" (click)="userUnBanClicked.emit(row)" aria-label="Unban">
        <mat-icon>add_circle</mat-icon>
      </button>
      <button mat-icon-button class="fa-button" color="primary" *ngIf="!row.hidden_silent" (click)="userSilentHideClicked.emit(row)" aria-label="Ban">
        <fa-icon [icon]="faGhost"></fa-icon>
      </button>
      <button mat-icon-button class="fa-button fa-button-gray" *ngIf="row.hidden_silent" (click)="userSilentUnhideClicked.emit(row)" aria-label="Unban">
        <fa-icon [icon]="faGhost"></fa-icon>
      </button>
    </mat-cell>
  </ng-container>

  <!-- The two identifiers the search box accepts. Shown so a search by id or
       email can be confirmed against the row it returned. -->
  <ng-container matColumnDef="user_id">
    <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header disableClear>ID</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">{{row.user_id}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="email">
    <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Email</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row" [title]="row.email">{{row.email}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="name">
    <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header disableClear>First Name</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">{{row.name}} <mat-icon color="primary" class="verified-icon" *ngIf="row.is_verified">verified</mat-icon></mat-cell>
  </ng-container>

  <ng-container matColumnDef="birth">
    <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Birthday</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">{{row.birth}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="gender">
    <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Gender</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">{{row.gender}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="is_mock_user">
    <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Mock User</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">{{isMockUser(row) ? 'Yes' : 'No'}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="country">
    <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header="location_label" disableClear>Location</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">{{row.location_label || row.detected_country}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="createdAt">
    <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Signed Up ({{ timezoneAbbr }})</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">{{row.createdAt | timezoneDate}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="last_activity">
    <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Last Activity ({{ timezoneAbbr }})</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">{{row.last_activity | timezoneDate}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="bannedAt">
    <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Banned At ({{ timezoneAbbr }})</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">{{row.bannedAt | timezoneDate}}</mat-cell>
  </ng-container>


  <ng-container matColumnDef="active">
    <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Status</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">{{row.active ? 'Active' : 'Inactive'}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="subscription_tier">
    <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header="is_select" disableClear>Subscription Tier</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">{{row.is_select ? 'Select' : (row.is_premium ? 'Premium' : 'Basic')}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="hidden_under_review">
    <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Under Review</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">{{row.hidden_under_review ? 'Yes' : 'No'}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="platform">
    <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header disableClear>OS</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">{{ row.platform }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="login_method">
    <mat-header-cell mat-header-cell *matHeaderCellDef>Login Method</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">{{ row.login_method | loginMethodLabel }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="os_version">
    <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header disableClear>OS Version</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">{{ row.os_version }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="app_version">
    <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header disableClear>App Version</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">{{ row.app_version }}{{ row.build_number ? ' (' + row.build_number + ')' : '' }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="device_model">
    <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Device</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">{{ row.device_model }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="report_count">
    <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Reported / Blocked</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">
      <span *ngIf="row.report_count > 0" class="report-count-badge">{{ row.report_count }}</span>
      <span *ngIf="row.report_count > 0 && row.block_count > 0" class="report-block-sep">/</span>
      <span *ngIf="row.block_count > 0" class="block-count-badge">{{ row.block_count }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="like_dislike_ratio">
    <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header="like_ratio" disableClear>Received Like/Dislike</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">{{ likeRatioLabel(row) }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="given_like_dislike_ratio">
    <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header="given_like_ratio" disableClear>Sent Like/Dislike</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">{{ givenLikeRatioLabel(row) }}</mat-cell>
  </ng-container>

  <!-- What kind of media this profile leads with. A video profile and a photo
       profile behave differently in the deck, and scanning for one of them is
       the reason this column exists. -->
  <ng-container matColumnDef="media">
    <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header="ready_video_count" disableClear>Media</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">
      <span class="media-badge media-video" *ngIf="row.ready_video_count > 0">
        Video<span class="media-count" *ngIf="row.ready_video_count > 1"> ×{{ row.ready_video_count }}</span>
      </span>
      <span class="media-badge media-pending"
            *ngIf="!row.ready_video_count && row.video_count > 0"
            title="Uploaded a video that is not playable yet">
        Video pending
      </span>
      <span class="media-badge media-photo"
            *ngIf="!row.video_count && row.profile_images?.length">
        Photo<span class="media-count" *ngIf="row.profile_images.length > 1"> ×{{ row.profile_images.length }}</span>
      </span>
      <span class="media-badge media-none"
            *ngIf="!row.video_count && !row.profile_images?.length">
        None
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="is_banned">
    <mat-header-cell mat-header-cell *matHeaderCellDef>Banned</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">
      <span *ngIf="row.is_banned" class="state-badge state-banned">Banned</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="hidden_silent">
    <mat-header-cell mat-header-cell *matHeaderCellDef>Silent Hidden</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">
      <span *ngIf="row.hidden_silent" class="state-badge state-silent">Silent</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="is_suspicious">
    <mat-header-cell mat-header-cell *matHeaderCellDef>Suspicious</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let row">
      <span *ngIf="row.is_suspicious" class="state-badge state-suspicious">Suspicious</span>
    </mat-cell>
  </ng-container>


  <!-- Message-flag columns. Only /message-flags asks for these; every other
       page's displayedColumns simply omits them. -->
  <ng-container matColumnDef="top_reasons">
    <mat-header-cell *matHeaderCellDef>Top Reasons</mat-header-cell>
    <mat-cell *matCellDef="let row">
      <span class="reason-chip" *ngFor="let item of row.top_reasons"
            [title]="item.label + ': ' + item.count">
        {{ item.label }} <b>{{ item.count }}</b>
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="flag_count">
    <mat-header-cell *matHeaderCellDef mat-sort-header="flag_count" disableClear>Flags</mat-header-cell>
    <mat-cell *matCellDef="let row">{{ row.flag_count }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="flagged_message_count">
    <mat-header-cell *matHeaderCellDef mat-sort-header="flagged_message_count" disableClear>Messages</mat-header-cell>
    <mat-cell *matCellDef="let row">{{ row.flagged_message_count }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="distinct_recipients">
    <mat-header-cell *matHeaderCellDef mat-sort-header="distinct_recipients" disableClear>Recipients</mat-header-cell>
    <mat-cell *matCellDef="let row">{{ row.distinct_recipients }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="last_flagged_at">
    <mat-header-cell *matHeaderCellDef mat-sort-header="last_flagged_at" disableClear>Last Flagged ({{ timezoneAbbr }})</mat-header-cell>
    <mat-cell *matCellDef="let row">{{ row.last_flagged_at | timezoneDate }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="flag_details">
    <mat-header-cell *matHeaderCellDef>Flags</mat-header-cell>
    <mat-cell *matCellDef="let row">
      <button mat-icon-button color="primary" (click)="flagDetailsClicked.emit(row); $event.stopPropagation()"
              aria-label="Flagged messages" title="Flagged messages">
        <mat-icon>flag</mat-icon>
      </button>
    </mat-cell>
  </ng-container>

  <mat-header-row  *matHeaderRowDef="isMobileLayout ? displayedColumnsMobile : displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: isMobileLayout ? displayedColumnsMobile : displayedColumns" [ngClass]="row.deletedAt ? 'danger' : (highlightIncomplete ? 'warn' : likeRatioRowClass(row))"></mat-row>
</table>
